export default "__VITE_ASSET__Dp1oreg3__"